import { Call } from '@twilio/voice-sdk';

// Custom event types for call management
export type CallEventType = 'call-created' | 'call-ended';

export interface CallEvent {
  type: CallEventType;
  call: Call | null;
  source: string; // Component that triggered the event
}

// Event listeners storage
const listeners: Array<(event: CallEvent) => void> = [];

// Subscribe to call events
export const subscribeToCallEvents = (listener: (event: CallEvent) => void) => {
  listeners.push(listener);
  
  // Return unsubscribe function
  return () => {
    const index = listeners.indexOf(listener);
    if (index > -1) {
      listeners.splice(index, 1);
    }
  };
};

// Emit call events
export const emitCallEvent = (event: CallEvent) => {
  listeners.forEach(listener => listener(event));
};

// Helper functions for common events
export const notifyCallCreated = (call: Call, source: string = 'unknown') => {
  emitCallEvent({
    type: 'call-created',
    call,
    source
  });
};

export const notifyCallEnded = (source: string = 'unknown') => {
  emitCallEvent({
    type: 'call-ended',
    call: null,
    source
  });
};
